import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-entity-mat-dialog-title',
  templateUrl: './entity-mat-dialog-title.component.html',
  styleUrls: ['./entity-mat-dialog-title.component.css']
})
export class EntityMatDialogTitleComponent implements OnInit {

  @Input() title: string;
  @Input() titleSuffix: string;
  @Input() closeData: any;

  constructor() { }

  ngOnInit(): void {
  }

}
